import React, {useContext, useEffect, useRef} from 'react';
import styled from "styled-components";
import AgenciesCard from "./agencies_card";
import {AgenciesContext} from "../../../providers/agencies_provider";
import {isEmpty} from "../../../helpers/helpers";
import AgenciesCardSkeleton from "./card_skeleton";
import CircleLoading from "@molecules/lotties/circle_loading";
import AgenciesSearchNoResult from "./agencies_search_no_result";
import RealtorsCard from "./realtors_card";
import IsRealtorBanner from "../../../molecules/banners/is.realtor";
import {UserContext} from "../../../providers/user";
import {array_chunk, is_array} from "../../../helpers/arrays";
import AgenciesHotLinks from "./agencies_hotlinks";
import ShomalCitiesSlider from "./shomal_cities_slider";

var allowRequest = true;

const AgenciesCards = ({ssrItems, ssrPageType, handleItemsLists, hotlinks, selectedCityId}) => {
    const loadMoreRef = useRef('');
    const agenciesContext = useContext(AgenciesContext);
    const userContext = useContext(UserContext);


    useEffect(() => {
        const handleScroll = (event) => {
            if (!isEmpty(loadMoreRef) && !isEmpty(loadMoreRef.current)) {
                const loadMoreBtn = loadMoreRef.current.offsetTop;

                const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
                const windowBottom = windowHeight + window.pageYOffset;

                if ((windowBottom > loadMoreBtn - 50) && hasMore && allowRequest) {
                    allowRequest = false;

                    const {page_type, city_id, district_id} = agenciesContext;

                    handleItemsLists(page_type, city_id, district_id, agenciesContext[page_type].page + 1, () => {
                        allowRequest = true
                    })
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    });


    const page_type = (!isEmpty(agenciesContext) && !isEmpty(agenciesContext.page_type)) ? agenciesContext.page_type : (!isEmpty(ssrPageType) ? ssrPageType : 'agencies');
    const items = (!isEmpty(agenciesContext) && !isEmpty(agenciesContext[page_type]) && agenciesContext[page_type].lists.length) ? agenciesContext[page_type] : ((!isEmpty(ssrItems) && !isEmpty(ssrItems[page_type])) ? ssrItems[page_type] : {});

    const {hasMore = false, lists = [], page = 1, total = 0} = items;
    const showSkeleton = !isEmpty(agenciesContext) ? agenciesContext.skeleton : false;

    return (
        <Container className="container xs-fluid">
            <div className="row mt-0 mt-lg-24">
                {
                    (!showSkeleton) ?
                        <React.Fragment>
                            {
                                (!isEmpty(lists) && lists.length) ?
                                    array_chunk(lists, 24).map((chunk, chunkKey) => {
                                        const evenPage = (chunkKey % 2 === 0);

                                        return (
                                            <React.Fragment>
                                                {
                                                    chunk.map((item, key) =>
                                                        <React.Fragment>
                                                            <div className="col-12 col-md-4 col-lg-3" key={item.id}>
                                                                {
                                                                    (page_type === 'agencies') ?
                                                                        <AgenciesCard agency={item} selectedCityId={selectedCityId} className="mx-24 mx-md-0"/>
                                                                        :
                                                                        <RealtorsCard realtor={item} className="mx-24 mx-md-0"/>
                                                                }
                                                            </div>

                                                            {
                                                                (key === 11 && chunkKey === 0 && selectedCityId === 3198) ?
                                                                    <React.Fragment>
                                                                        <SliderSection className="col-12 ">
                                                                            <ShomalCitiesSlider pageType={page_type} handleItemsLists={handleItemsLists}/>
                                                                        </SliderSection>

                                                                        <div className="col-12 d-block d-md-none">
                                                                            <SliderSectionDivider className="d-block d-md-none mx-24 mx-md-0"/>
                                                                        </div>
                                                                    </React.Fragment>
                                                                    : ''
                                                            }
                                                        </React.Fragment>
                                                    )
                                                }

                                                {
                                                    (evenPage && is_array(hotlinks) && hotlinks.length) ?
                                                        <div className="col-12">
                                                            <Section className="mx-24 mx-md-0">
                                                                <AgenciesHotLinks
                                                                    items={hotlinks}
                                                                    className="border-transparent"
                                                                />
                                                            </Section>
                                                        </div>
                                                        : ''
                                                }

                                                {
                                                    (!evenPage && !isEmpty(userContext) && !userContext.check) ?
                                                        <div className="col-12">
                                                            <Section className="mx-24 mx-md-0">
                                                                <IsRealtorBanner/>
                                                            </Section>
                                                        </div>
                                                        : ''
                                                }
                                            </React.Fragment>
                                        )
                                    })
                                    :
                                    <div className="col-12">
                                        <div className="mx-24 mx-md-0">
                                            <AgenciesSearchNoResult/>
                                        </div>
                                    </div>
                            }
                        </React.Fragment>
                        :
                        [...Array(12)].map((i, k) =>
                            <div className="col-12 col-md-4 col-lg-3" key={k}>
                                <div className="mx-24 mx-md-0">
                                    <AgenciesCardSkeleton/>
                                </div>
                            </div>
                        )
                }

                {
                    !showSkeleton && hasMore &&
                    <div ref={loadMoreRef} className="col-12 align-items-center justify-content-center mt-56">
                        <div className="d-flex align-items-center justify-content-center mx-24 mx-md-0">
                            <div><CircleLoading width={32} height={32}/></div>
                            <p className="h3 mr-8">در حال دریافت...</p>
                        </div>
                    </div>
                }
            </div>
        </Container>
    );
};

export default React.memo(AgenciesCards);

// styles

const Container = styled.div`
  @media (max-width: ${props => props.theme.screenXsMax}) {
    .row {
      margin-right: 0 !important;
      margin-left: 0 !important;

      [class*="col-"] {
        padding-right: 0 !important;
        padding-left: 0 !important;
      }
    }
  }
`

const Section = styled.div`
  padding: 80px 0 64px;

  @media (max-width: ${props => props.theme.screenSmMax}) {
    padding: 64px 0;
    border-bottom: 1px solid ${props => props.theme.gray200};
  }
`;

const SliderSection = styled.div`
  padding: 80px 0 40px;

  @media (max-width: ${props => props.theme.screenSmMax}) {
    padding: 64px 0 40px;

    .section-divider {
      border-bottom: 1px solid ${props => props.theme.gray200};
    }
  }
`;

const SliderSectionDivider = styled.div`

  @media (max-width: ${props => props.theme.screenSmMax}) {
    border-bottom: 1px solid ${props => props.theme.gray200};
  }
`;